<template>
  <div class="invite-rule">
    <h2>活动说明</h2>
    <div class="desc-item">
      <div>
        <span class="dot">• </span>
        <span class="content">参与人群：所有熊猫签证注册用户</span>
      </div>
      <div>
        <span class="dot">• </span>
        <span class="content"
          >如何邀请：用户进入邀请拿奖励页面，点击“邀请好友”并将信息分享给好友，即完成邀请操作。</span
        >
      </div>
    </div>

    <h2>奖励说明</h2>
    <div class="desc-item">
      <div>
        <span class="dot">• </span>
        <span class="content"
          >受邀用户注册成功（限新注册用户），邀请人可获得{{
            sysConfigCoupon.register_balance / 100
          }}元余额奖励，每个用户最多可获得{{
            sysConfigCoupon.register_max_times
          }}次邀请余额奖励，最高可获得{{
            (sysConfigCoupon.register_balance *
              sysConfigCoupon.register_max_times) /
            100
          }}元余额奖励（具体额度可能随活动进行发生改变）；</span
        >
      </div>
      <!-- <div>
        <span class="dot">• </span>
        <span class="content">被邀请的新用户，可获得{{sysConfigCoupon.cash_reduce / 100}}元优惠券一张。</span>
      </div> -->
      <div>
        <span class="dot">• </span>
        <span class="content"
          >余额相关说明请
          <router-link :to="{ name: 'moneyUsage' }">点击这里</router-link></span
        >
      </div>
    </div>

    <h2>其他说明</h2>
    <div class="desc-item">
      <div>
        <span class="dot">• </span>
        <span class="content"
          >通过不正当手段获得奖励，包括但不限于邀请无效手机号等，熊猫签证有权在不提前通知用户的前提下撤销其所获得的奖励余额及相关交易订单，同时保留追究其法律责任的权利。</span
        >
      </div>
      <div>
        <span class="dot">• </span>
        <span class="content">对本活动有任何疑问，请联系熊猫签证客服。</span>
      </div>
      <div>
        <span class="dot">• </span>
        <span class="content">熊猫签证保留对该活动的最终解释权。</span>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../services/tools.js';
import systemService from '../services/systemService';

export default {
  data() {
    return {
      sysConfigCoupon: {},
    };
  },
  created() {
    utils.setTitle('邀请拿奖励活动规则');
    this.sysConfigGet();
  },
  methods: {
    /**
     * 获取系统配置
     */
    sysConfigGet() {
      systemService.sysConfigGet().then((data) => {
        this.sysConfigCoupon = data.coupon;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '../styles/theme.less';

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.invite-rule {
  background-color: white;
  min-height: 100%;
  padding: 0.37rem 0.11rem 0.3rem 0.11rem;
  letter-spacing: 0.0015rem;
}

h2 {
  font-size: 0.16rem;
  font-weight: 600;
  color: #444444;
  padding-left: 0.11rem;
  position: relative;

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    height: 0.15rem;
    left: 0;
    width: 0.03rem;
    border-radius: 0.1rem;
    background-color: @red;
  }
}

div.desc-item {
  font-size: 0.14rem;
  line-height: 0.24rem;
  color: #6f6f6f;
  margin-top: 0.1rem;
  padding-left: 0.11rem;
  margin-bottom: 0.25rem;
  div {
    display: flex;
    justify-content: flex-start;
    span.dot {
      width: 0.1rem;
    }
    span.content {
      flex: 1;
    }
  }
}

p + h2 {
  margin-top: 0.28rem;
}

a {
  color: @red;
  text-decoration: underline;
}
</style>
